<template>
  <div class="login">
    <div class="ani logo" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
      <a href="#home">
        <img src="../assets/logo.png">
      </a>
    </div>
    <div class="login-bg"></div>
    <div class="login-form">
      <div class="login-top">
        <h1>CIS</h1>
        <span>
          Cargo information
          <br>system
        </span>
      </div>
      <div class="login-box">
          <label class="username">User Name</label>
          <input
            type="text" 
            v-model="username"
            :class="{ error: usernameIsEmpty }" 
            :placeholder="usernamePlaceholder" 
            @focus="handleUsernameFocus" />
          <label class="username">Password</label>
          <input 
            type="password" 
            v-model="password" 
            :class="{ error: passwordIsEmpty }"
            :placeholder="passwordPlaceholder" 
            @focus="handlePasswordFocus" />
          <label class="username">Office</label>
          <select name="office">
              <option value="Office">Office</option>
          </select>
          <div class="login-other">
            <a class="register" :href="registerUrl">Register One!</a>
            <a class="forget" :href="forgotPasswordUrl">Forget password</a>
          </div>
          <a href="#" class="login-btn" @click="handleLogin">Login</a>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'blueimp-md5';
import { LOGIN_SIGN_KEY, LOGIN_URL, REGISTER_URL, FORGOT_PASSWORD_URL } from '../config/';

const USERNAME_PLACEHOLDER = 'User Name';
const USERNAME_EMPTY = 'Please enter the User Name';

const PASSWORD_PLACEHOLDER = 'Password';
const PASSWORD_EMPTY = 'Please enter the Password';

export default {
  name: "login",
  data() {
    return {
      username: '',
      usernameIsEmpty: false,
      password: '',
      passwordIsEmpty: false,
    };
  },
  computed: {
    usernamePlaceholder() {
      if (!this.usernameIsEmpty) {
        return USERNAME_PLACEHOLDER;
      } else {
        return USERNAME_EMPTY;
      }
    },
    passwordPlaceholder() {
      if (!this.passwordIsEmpty) {
        return PASSWORD_PLACEHOLDER;
      } else {
        return PASSWORD_EMPTY;
      }
    },
    registerUrl() {
      return REGISTER_URL;
    },
    forgotPasswordUrl() {
      return FORGOT_PASSWORD_URL;
    },
  },
  methods: {
    handleUsernameFocus() {
      this.usernameIsEmpty = false;
    },
    handlePasswordFocus() {
      this.passwordIsEmpty = false;
    },
    handleLogin() {
      if (this.username.length === 0) {
        this.usernameIsEmpty = true;
      }
      if (this.password.length === 0) {
        this.passwordIsEmpty = true;
      }
      if (!this.usernameIsEmpty && !this.passwordIsEmpty) {
        const sign = md5(`${LOGIN_SIGN_KEY}&${this.username}&${this.password}`);
        window.location.href = `${LOGIN_URL}?Sign=${sign}&UserName=${this.username}&Password=${this.password}`;
      }
      return false;
    },
  }
};
</script>

<style>
.login{
    height: 100%;
    background: #edeff2;
}
.login-bg {
  width: 100%;
  height: 280px;
  background: #3279db;
}
.login-form {
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  top: -150px;
}
.login-top h1 {
  font-size: 60px;
  float: left;
  color: #fff;
}
.login-top span {
  color: #fff;
  display: inline-block;
  margin: 18px 0 0 5px;
}
.login-box{
    background: #fff;
    padding: 92px 160px;
    margin-top: 40px;
}
.login-box input,.login-box select{
    display: block;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    outline: none;
    width: 100%;
    padding: 10px 0;
    margin:  0 0 10px 0;
    font-size: 14px;
}
.login-box select{
    color: #777;
}
.login-box input:focus{
    border-bottom: 1px solid #3279db;  
}
.login-box .username{
    color: #3279db;
    font-size: 12px;
}
.login-other{
    overflow: hidden;
}
.login-other .register{
    float: left;
    font-size: 14px;
    color: #333;
}
.login-other .forget{
    float: right;
    font-size: 14px;
    color: #3279db;
    padding-left: 20px;
    background: url(../assets/lock.png) no-repeat left;
}
.login-btn{
    display: inline-block;
    text-align: center;
    color: #fff;
    background: #3279db;
    border: none;
    width: 100%;
    padding: 15px 0;
    font-size: 16px;
    margin-top: 40px;
}
.login-box .error {
    border-bottom: 1px solid red;
}
.login-box .error::-webkit-input-placeholder {
    color: red;
}
.login-box .error:-moz-placeholder {
    color: red;
}
.login-box .error::-moz-placeholder {
    color: red;
}
.login-box .error:-ms-input-placeholder {
    color: red;
}
@media screen and (max-width: 776px) {
 .login-box{
     padding: 30px;
 }
   .logo{
    left: 25px;
    top: 20px;
    width: 54px;
  }
  .logo img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Login.vue